var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('Header',{attrs:{"path":_vm.path}}),_c('v-main',[_c('router-view',{class:{ 'body-top': _vm.path !== '/' }}),_c('ToTopButton',{attrs:{"path":_vm.path}})],1),_c('Footer',{attrs:{"path":_vm.path}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }